<template>
  <div class="main">
    <div class="main-back">
      <div class="topcontent">
        <div class="main-img">
          <img src="@/assets/wyyh_bocom/header-01.png" alt="" />
        </div>
      </div>

      <div class="condition-display">
        <div class="menu-replace" style="height: 0px">
          <!--当导航固定定位时顶替导航的空缺高度，避免页面跳动-->
        </div>
        <div class="detail-tab detailtab" id="nav-menu">
          <a class="detail-tab-item active2">产品详情</a>
          <a class="detail-tab-item">产品说明书</a>
        </div>
        <div class="section-content productDetail" id="tab1">
          <img
            class="productDetail-img1"
            src="@/assets/wyyh_bocom/01.png"
            alt=""
          />
          <img
            class="productDetail-img2"
            src="@/assets/wyyh_bocom/02.png"
            alt=""
          />
          <img
            class="productDetail-img3"
            src="@/assets/wyyh_bocom/03.png"
            alt=""
          />
        </div>
        <div class="section-content" id="tab2">
          <img
            class="productDetail-img4"
            src="@/assets/wyyh_bocom/04.png"
            alt=""
          />
          <div class="case">
            <ul>
              <li>
                <a
                  href="pdf/wyyh/anleitung1.pdf"
                  >招商信诺终身寿险B款产品说明书</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="reminder">
          页面内容仅供参考，不构成保险合同组成部分，保险责任、责任免除、等待期、理赔要求等重点内容，以保险合同为准。<br/>
          *保险产品：招商信诺稳赢一号终身寿险保险产品计划<br/>
          *承保公司：招商信诺人寿保险有限公司<br/>
          *代理机构：交通银行股份有限公司太平洋信用卡中心<br/>
          *保险产品适用条款：<a href="pdf/wyyh/clause1.pdf">《招商信诺终身寿险B款条款》</a><br/>
          *条款编码：招商信诺【2023】终身寿险017号<br/>
          *消费者投诉维权途径：<br/>
           保险公司客服电话：95362<br/>
          卡中心客服电话：4008009888
        </div>
        <div class="yy">
          <img src="../../assets/public/s.gif" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/utils/navScroll";
export default {
  name: "index",
  data() {
    return {};
  },
  mounted() {
    let navHeight =
      document.getElementsByClassName("menu-replace")[0].offsetParent.offsetTop;
    // console.log(document.getElementsByClassName("menu-replace")[0].getBoundingClientRect())
    let navFix = document.getElementById("nav-menu");
    let menuH = navFix.offsetHeight;
    console.log(navHeight, menuH);
    /**
     * 监听滚动条
     */
    this.ismenutop(navHeight, navFix, menuH);
    window.removeEventListener("scroll", () => {
      this.ismenutop(navHeight, navFix, menuH);
    });
    window.addEventListener("scroll", () => {
      this.ismenutop(navHeight, navFix, menuH);
    });
    /*导航定位*/
    new hScroll({
      nav1: ".detailtab a", //导航对应的元素
      nav2: ".section-content", //监听的元素
      nav3: menuH, //导航栏高度
      checkClass: "active2", //选中的样式
    });
  },
  methods: {
    // 判断导航栏是否置顶
    ismenutop(navHeight, navFix, menuH) {
      let scrollTop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      let menuReplace = document.getElementsByClassName("menu-replace")[0];
      if (menuReplace) {
        if (scrollTop > navHeight) {
          navFix.classList.add("nav-fixed");
          menuReplace.style.height = menuH + "px";
        } else {
          navFix.classList.remove("nav-fixed");
          menuReplace.style.height = 0;
        }
      }
    },
  },
};
</script>

<style scoped>
.main {
  width: 3.75rem;
  margin: 0 auto;
}

.main-back {
  width: 100%;
  background-color: #f4f6f9;
  padding-bottom: 0.71rem;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.16rem 0;
}

.header img {
  width: 0.2rem;
  height: 0.2rem;
  margin-left: 0.16rem;
}

.header-title {
  font-size: 0.17rem;
  font-weight: bold;
}

.main-img,
.marshalling {
  width: 100%;
}

.main-img img {
  width: 3.75rem;
  height: 1.8rem;
  display: block;
}

.condition-display {
  position: relative;
}

.menu-replace {
  position: relative;
  width: 100%;
  height: 0;
}

.detail-tab {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  border-bottom: solid 1px #f0f0f0;
}

.nav-fixed {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  _position: absolute;
  _bottom: auto;
  _top: expression(eval(document.documentElement.scrollTop));
}

.navtab {
  position: fixed !important;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
}

.detail-tab-item {
  font-size: 0.14rem;
  color: #9da5b1;
  padding: 0.155rem 0 0.11rem;
  font-weight: bold;
}

.active2 {
  color: #000000;
  position: relative;
  font-weight: bold;
}

.active2::after {
  content: "";
  width: 0.17rem;
  height: 0.02rem;
  background-color: #000000;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.productDetail {
  background-color: #ffffff;
}

.productDetail img {
  display: block;
  /* width: 3.4rem; */
}

.productDetail .productDetail-img1 {
  width: 3.75rem;
  height: 2.63rem;
  margin: 0 auto;
}

.productDetail-img2 {
  width: 3.75rem;
  height: 4.88rem;
  margin: 0 auto;
}
.productDetail-img3 {
  width: 3.75rem;
  height: 6.86rem;
  margin: 0 auto;
}
.productDetail-img4 {
  width: 3.75rem;
  margin: 0 auto;
}
.productDetail-img5 {
  width: 3.75rem;
  height: 4rem;
  margin: 0 auto;
}
.case {
  padding: 0.125rem 0.1rem 0;
}

.case ul {
  padding: 0;
  margin: 0;
}

.case ul li {
  background-color: #fff;
  padding: 0.1rem 0.42rem 0.1rem 0.505rem;
  position: relative;
  margin-bottom: 0.1rem;
  border-radius: 7px;
}

.case ul li a {
  display: block;
  color: #333;
  font-size: 0.13rem;
}

.case ul li::before {
  position: absolute;
  content: "";
  background: url("../../assets/public/pdf.png") no-repeat center center;
  background-size: 0.28rem 0.29rem;
  width: 0.28rem;
  height: 0.29rem;
  left: 0.115rem;
  top: 0.05rem;
}

.case ul li::after {
  position: absolute;
  content: "";
  background: url(../../assets/public/icon-07.png) no-repeat center center;
  background-size: contain;
  width: 0.17rem;
  height: 0.17rem;
  right: 0.195rem;
  top: 0.11rem;
}

.reminder p {
  color: #999;
  font-size: 0.1rem;
  margin-bottom: 0.09rem;
}
.reminder {
  padding: 0.05rem 0.1rem 0;
  color: #999;
  font-size: 0.1rem;
  line-height: 0.14rem;
}
.reminder>a{
  color: #fc9b20;
  font-size: 0.1rem;
  line-height: 0.14rem;
}
</style>
